import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

// axios.defaults.baseURL = 'http://localhost:3000'
axios.defaults.baseURL = 'https://vps.zhrleather.com'


import './style.css'
import './assets/icons/icomoon/styles.min.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
